import { ChipField, Datagrid, DateField, List, NumberField, ReferenceField, TextField } from 'react-admin';

const CourseList = () => {
	return (
		<List>
			<Datagrid rowClick="edit">
				<TextField source="title.he" label="כותרת בעברית" />
				<TextField source="title.en" label="כותרת באנגלית" />
				<DateField source="startDate" label="תאריך התחלה" />
				<NumberField source="users" label="משתמשים" />
				<NumberField source="completedUsers" label="משתמשים שסיימו" />
				<ReferenceField reference="instructor/all" source="expert" label="מדריך">
					<ChipField source="name" />
				</ReferenceField>
			</Datagrid>
		</List>
	);
};
export default CourseList;
